import { Service } from '@genial/services';
import { selectorFamily } from 'recoil';

import { screenName } from '../constants';
import { normalizeFixedIncomeWithdrawGetFixedIncomeAsset } from '../normalize';
import { FixedIncomeWithdrawAssetNormalized } from '../types';

export const fixedIncomeWithdrawGetAsset = selectorFamily<
  FixedIncomeWithdrawAssetNormalized | null | undefined,
  { accountId: number; productId: number }
>({
  key: 'redemptionSolicitation/fixedIncomeWithdrawGetAsset',
  get: ({ accountId, productId }) => {
    return async () => {
      const { data } = await Service.FixedIncome.V1.getWithdrawByUniqueCodeCurrentAccountIdDetails({
        screenName,
        accountId,
        uniqueCode: productId,
      });

      if (!data) {
        throw new Error('Ocorreu um erro ao carregar os dados do fundo');
      }

      const normalizedData = normalizeFixedIncomeWithdrawGetFixedIncomeAsset(data);

      return normalizedData;
    };
  },
});
